let initialState = {
  dataSearch: {},
  goBack: false,
  namThanhTra: []
}

function danhSachKHThanhTra(state = initialState, action) {
  let newState = {
    ...state
  };
  switch (action.type) {
    case 'SET_NAM_THANH_TRA':
      newState.namThanhTra = action.data;
      return newState;
    case 'DSTT_GO_BACK':
      newState.goBack = true;
      return newState;
    case 'DSTT_RESET_GO_BACK':
      newState.goBack = false;
      return newState;
    default:
      return newState;
  }
}

export { danhSachKHThanhTra }



// WEBPACK FOOTER //
// ./src/reducers/danhSachKHThanhTra.js